<template>
  <div id="main-content">
    <section v-if="submitPolicyInProcess">
      <h1>{{ submitPolicyInProcessHeader }}</h1>
      <p v-html="ErrorStrings.SUBMIT_POLICY_IN_PROCESS_ERROR.SUBHEADER"></p>
    </section>
    <SuccessBanner v-if="!submitPolicyInProcess" :header="$route.meta.title">
      <div v-if="showContents" class="top-content" v-html="refData.noImpactInformationText.informationText" />
    </SuccessBanner>
    <template v-if="relatedPages && !submitPolicyInProcess"> 
      <h2 class="hidden">Related pages</h2>
      <QuickLinks :linksData="[relatedPages.relatedPage1, relatedPages.relatedPage2, relatedPages.relatedPage3]" />
    </template>
  </div>
</template>

<script>
import { QuickLinks, SuccessBanner } from '@/components';
import { ErrorStrings } from '@general/js/constants';
import { generateSubmitPolicyInProcessHeader } from '@/utils/DisplayUtils';
import MemberDetailsMixin from './MemberDetailsFormSteps/MemberDetailsMixin';

export default {
  name: 'NoImpactResult',

  components: {
    QuickLinks,
    SuccessBanner,
  },

  props: {
    /**
     * Flow name to be used in generating submit policy in process header.
     * This prop is only required if `submitPolicyInProcess` is true.
     */
    flowName: {
      type: String,
      required: false,
    },
  },

  mixins: [MemberDetailsMixin],

  data() {
    return {
      informationText: '',
      ErrorStrings,
    };
  },

  computed: {
    showContents() {
      return this.refData?.noImpactInformationText?.informationText;
    },

    relatedPages() {
      const refData = this.refData;
      const pages = [refData?.relatedPage1, refData?.relatedPage2, refData?.relatedPage3];
      const returnObj = {};

      const relatedPagesAvailable = pages.some(Boolean);
      if (!relatedPagesAvailable) {
        return false;
      }

      pages.forEach((page, index) => {
        returnObj[`relatedPage${index + 1}`] =
          page !== null && page !== undefined
            ? {
                ...page,
                imageUrl: page?.imageUrl.replace(/^~/, ''),
              }
            : null;
      });

      return returnObj;
    },

    submitPolicyInProcessHeader() {
      return generateSubmitPolicyInProcessHeader(
        this.flowName,
        this.submitPolicyInProcess
      );
    },
  },

  beforeMount() {
    this.informationText = this.refData?.noImpactInformationText?.informationText;
  },

  beforeUnmount() {
    this.updateSubmitUpdateSuccessful(false);
  },
};
</script>

<style lang="scss" scoped>
.hidden {
  /** this class hides <h2> as per design but due to accessibility, <h2> is required, to pass accessibility, and screen reader, change opacity hence it is hidden and use as spacing between top content and quick links */
  opacity: 0.01; // use opacity instead of display none or visibility hidden to pass accessibility
  margin-bottom: 0;
  height: spacer(5); // for spacing between top content and quick links, which is 70px as per design suggested (20px is coming from <QuickLinks> style)
  overflow: hidden;
}

#quick-links {
  margin-bottom: 3rem;
}
</style>
